import { FunctionalComponent, h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import { useAppSelector } from "../../redux/hooks";
import { isMobileOnly } from "react-device-detect";
// import { TopBarTheme } from "../../models/enums";
// import { Labels } from "../../models/labels";
import KorraPdfViewer from "../../components/korraPdfViewer";
import CloseIcon from "../../assets/icons/closeIcon";
// import TopBar from "../../components/topBar";

import mobile from "./mobile.css";
import desktop from "./desktop.css";
import WatermarkOverlay from "../../components/DocumentWaterMark"

interface Props {
  workspaceId: string;
  kappId: string;
  portalId?: string;
  docId: string;
  page: string;
  guid: string;

  workspaceAlias?: string;
  portalAlias?: string;

  matches: {
    highlight?: string;
  };
  chatbotFlag?: string;
  isDrawerOpen?: boolean;
  isMobileExpand?: boolean;
  selectRef?: any;
  sasToken?: string;
}

const ChatbotPdf: FunctionalComponent<Props> = (props: Props) => {
  const {
    workspaceId,
    kappId,
    portalId,
    docId,
    page,
    guid,
    workspaceAlias,
    portalAlias,
    matches,
    chatbotFlag,
    isDrawerOpen,
    isMobileExpand,
    selectRef,
    sasToken,
  } = props;

  const highlight = matches.highlight === "false" ? false : true;

  const appearance = useAppSelector((state) => state.appearance);
  const alias = useAppSelector((state) => state.alias);
  const globals = useAppSelector((state) => state.globals);
  const chatbot = useAppSelector((state) => state.chatbot);

  // const [isFullscreen, setIsFullscreen] = useState(false);
  const routeTo = (r: any) => {
    route(r?.detail);
  };
  const setListeners = () => {
    (window as any).addEventListener("route-to", routeTo);
  };

  useEffect(() => {
    setListeners();
    if (isDrawerOpen) {
      document.title = "Korra Pdf Viewer";

      (window as any).addEventListener("korra-file-name", (r: any) => {
        if (r?.detail)
          document.title = r.detail.split("/")[r.detail.split("/").length - 1];
      });
      setTimeout(() => {
        if (isMobileOnly) {
          // !!
          let el = document.getElementById("viewerContainer");
          if (el) el.style.position = "fixed";
        }
      }, 50);
    }
  }, [isDrawerOpen]);

  return (
    <div className={isMobileExpand ? mobile.container : desktop.containerNew}>
      {appearance.documentWatermark && (
          <WatermarkOverlay />
        )}
      {isDrawerOpen && (
        <KorraPdfViewer
          companyid={workspaceId || alias.workspaceId}
          portalid={portalId || alias.portalId}
          kappid={kappId}
          workspaceAlias={workspaceAlias}
          portalAlias={portalAlias}
          docguid={docId}
          guid={guid}
          page={page}
          mode={appearance.mode || undefined}
          options={JSON.stringify(appearance)}
          fileRepositoryDestinationLink={
            chatbotFlag &&
            chatbot.chabotThemeSettings?.enableFileRepositoryDestinationLink
              ? chatbot.chabotThemeSettings?.fileRepositoryDestinationLink
              : appearance.enableFileRepositoryDestinationLink
              ? appearance.fileRepositoryDestinationLink
              : ""
          }
          enableFileRepositoryDestinationLink={
            chatbotFlag
              ? chatbot.chabotThemeSettings?.enableFileRepositoryDestinationLink
              : appearance.enableFileRepositoryDestinationLink
          }
          highlight={chatbotFlag ? true : appearance.highlightPdf}
          jwtUserIdToken={globals.jwtUserIdToken || undefined}
          userId={globals.userId || undefined}
          select_text={highlight}
          chatbotFlag={chatbotFlag}
          selectRef={selectRef}
          sasToken={sasToken}
        />)}
        
    </div>
  );
};

export default ChatbotPdf;
